<template>
  <div class="banner">
    <b-row>
      <b-col cols="4">
        <p class="text-header">จัดการที่ว่างต่อสาขา</p>
      </b-col>
    </b-row>

    <div class="tw-bg-white tw-mt-4">
      <b-tabs
        content-class="mt-3"
        active-nav-item-class="font-weight-bold"
        v-model="tabIndex"
      >
        <b-tab title="สาขา">
          <div v-if="tabIndex === 0" class="px-3">
            <b-row class="mb-2">
              <b-col cols="8" offset="4">
                <div class="d-flex justify-content-end">
                  <div class="g-form">
                    <div class="input">
                      <b-form-input
                        v-model="filter.keyword"
                        placeholder="ค้นหา"
                        @focus="iconSearch = true"
                        @blur="iconSearch = false"
                        @keyup.enter="handleSearch"
                      ></b-form-input>
                      <b-button
                        class="search"
                        :class="iconSearch ? 'active-border' : ''"
                        @click="handleSearch"
                      >
                        <b-icon
                          stacked
                          icon="search"
                          scale="0.5"
                          variant="grey"
                        ></b-icon>
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <Table
              :items="items"
              :fields="fields"
              :isBusy="isBusy"
              :rows="rows"
              :filter="filter"
              :pageOptions="pageOptions"
              @editCategory="onClickEditCategory"
              @filterPage="filterPage"
              @onChangeStatus="onChangeStatus"
            /></div
        ></b-tab>
        <b-tab title="กำหนดเอง">
          <div v-if="tabIndex === 1" class="px-3">
            <b-row class="mb-2">
              <b-col cols="8" offset="4">
                <div class="d-flex justify-content-end">
                  <div class="g-form">
                    <div class="input">
                      <b-form-input
                        v-model="filter.keyword"
                        placeholder="ค้นหา"
                        @focus="iconSearch = true"
                        @blur="iconSearch = false"
                        @keyup.enter="handleSearch"
                      ></b-form-input>
                      <b-button
                        class="search"
                        :class="iconSearch ? 'active-border' : ''"
                        @click="handleSearch"
                      >
                        <b-icon
                          stacked
                          icon="search"
                          scale="0.5"
                          variant="grey"
                        ></b-icon>
                      </b-button>
                    </div>
                  </div>
                  <b-button class="btn-filter" @click="onClickCreate()">
                    <span class="d-none d-md-block">
                      <span class="">สร้าง</span>
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <Table
              :items="items"
              :fields="fields"
              :isBusy="isBusy"
              :rows="rows"
              :filter="filter"
              :pageOptions="pageOptions"
              @editCategory="onClickEditCategory"
              @filterPage="filterPage"
              @onChangeStatus="onChangeStatus"
            /></div
        ></b-tab>
      </b-tabs>
    </div>
    <SlotForm
      :visible="visible"
      :id="0"
      @hideForm="hideForm"
      @fetchTable="getList"
    />
  </div>
</template>

<script>
import Table from "./component/table.vue";
import SlotForm from "./component/slotForm.vue";
export default {
  name: "CategoryPage",
  components: {
    Table,
    SlotForm,
  },
  data() {
    return {
      //state
      tabIndex: 0,
      id: 0,

      // state toggle
      iconSearch: false,
      visible: false,

      // state table
      items: [],

      pageOptions: [
        { value: 5, text: "5 / หน้า" },
        { value: 10, text: "10 / หน้า" },
        { value: 15, text: "15 / หน้า" },
        { value: 20, text: "20 / หน้า" },
      ],
      isBusy: false,
      filter: {
        search: null,
        listBrandId: null,
        listBranchId: null,
        isCustom: false,
        page: 1,
        take: 10,
      },
      rows: 0,

      // state modal
      textModal: "",
      arrStatus: [],
    };
  },
  computed: {
    fields() {
      if (this.tabIndex == 1)
        return [
          {
            key: "name",
            label: "ชื่อ",
            class: "w-100px text-nowrap",
          },
          {
            key: "defaultSlot",
            label: "จำนวนที่ว่าง",
            class: "w-100px text-nowrap",
          },

          { key: "actions", label: "ดำเนินการ", class: "w-100px text-nowrap" },
        ];
      return [
        {
          key: "name",
          label: "ชื่อ",
          class: "w-100px text-nowrap",
        },
        {
          key: "brand",
          label: "แบรนด์",
          class: "w-100px text-nowrap",
        },
        {
          key: "branch",
          label: "สาขา",
          class: "w-100px text-nowrap",
        },
        {
          key: "defaultSlot",
          label: "จำนวนที่ว่าง",
          class: "w-100px text-nowrap",
        },
        { key: "actions", label: "ดำเนินการ", class: "w-50px text-nowrap" },
      ];
    },
  },
  watch: {
    tabIndex(newValue) {
      this.changeTab(newValue);
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    onClickCreate() {
      this.visible = true;
    },
    changeTab(index) {
      this.filter = {
        ...this.filter,
        page: 1,
        isCustom: Boolean(index),
      };
      this.getList();
    },
    async getList() {
      this.isBusy = true;
      const respone = await this.$services.slotgroup.getSlotGroupList(
        this.filter
      );
      if (respone.result === 1) {
        const { data, count, skip, take } = respone.detail;
        this.items = data;

        this.rows = count;
      }
      this.isBusy = false;
    },
    handleSearch() {
      this.filter.page = 1;
      this.getList();
    },
    onClickEditCategory(val) {
      const { id } = val;
      this.id = id;
      this.visible = true;
    },
    filterPage(obj) {
      let { page } = obj;
      this.filter.page = page;

      this.getList();
    },
    async onChangeStatus(val) {
      const { id, isActive } = val;

      const respone = await this.$services.category.setStatus(id, isActive);
    },
    hideForm() {
      this.id = 0;
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  .g-form {
    width: 100%;
    margin-right: 10px;
  }
  .text-header {
    color: #092d53;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
  }
  .div-divide {
    border-bottom: 1px solid darkgray;
    padding: 10px 0px;
  }

  .header-title {
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
  }

  .render-image {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 200px;
    border: 1px dashed gray;
  }
}
</style>
